import Reveal from "@/components/base/Reveal";
import { Link } from "react-router-dom";

export default function KonaseemaCta() {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="w-full px-4 md:px-8">
        <Reveal>
          <div className="relative rounded-lg overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Fresh%20morning%20view%20of%20a%20wooden%20boat%20on%20a%20calm%20Konaseema%20backwater%20canal%20lined%20with%20coconut%20palms%2C%20fresh%20reflections%2C%20painterly%20stylized%20earthy%20green%20tones%2C%20flooded%20with%20golden%20sunrise%20light%2C%20warm%20amber%20sunrays%20and%20soft%20glow%2C%20misty%20atmospheric%20haze%2C%20deep%20rich%20shadows%2C%20vivid%20saturated%20lush%20green%2C%20high%20contrast%20cinematic%20golden%20hour%20richness%2C%20ultra%20detailed&nocache=true&width=1920&height=760&seq=konaseema-cta&orientation=landscape"
              width={1920}
              height={760}
              alt="Fresh morning on a Konaseema backwater canal"
              title="Explore Konaseema with Rythugaru agri tourism"
              className="w-full h-72 md:h-[26rem] object-cover object-top"
              decoding="async"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-black/30"></div>
            <div className="absolute inset-0 flex items-center">
              <div className="w-full px-6 md:px-14 max-w-3xl">
                <h2 className="font-heading text-3xl md:text-5xl leading-tight text-background-50 font-semibold">
                  Come Experience the Life Behind Your Food
                </h2>
                <p className="mt-5 text-base text-background-100 leading-relaxed max-w-xl">
                  Follow the road to the farm, meet the farmers of Konaseema, and reconnect with
                  the roots.
                </p>
                <div className="flex flex-col sm:flex-row gap-3 mt-8">
                  <Link
                    to="/#experiences"
                    className="inline-flex items-center justify-center gap-2 bg-accent-500 text-background-50 text-sm font-semibold px-7 py-4 rounded-md hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Explore Experiences
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                  <Link
                    to="/farmers"
                    className="inline-flex items-center justify-center gap-2 bg-background-50/10 backdrop-blur-sm border border-background-50/40 text-background-50 text-sm font-semibold px-7 py-4 rounded-md hover:bg-background-50/20 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Meet Our Farmers
                    <i className="ri-user-heart-line"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}